import React, {Component} from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { withRouter } from "react-router-dom"
import ApiHelper from "./ApiHelper"
import axios from "axios"
import DeveloperPortalCompanies from "./containers/DeveloperPortalCompanies"
import DeveloperPortalCredentials from "./containers/DeveloperPortalCredentials"
import DeveloperPortalSummary from "./containers/DeveloperPortalSummary"
import DeveloperPortalBrokerage from "./containers/DeveloperPortalBrokerage"
import DeveloperPortalArthScoreFactors from "./containers/DeveloperPortalArthScoreFactors"
class DeveloperPortal extends Component{
    constructor(props){
        super(props)
        this.state = {
            developerPortalStyle:{
                display: "none"
            },
            tabnumber: 1,
            loading: true
        }
    }
    setLoading(flag){
        const newstate = {...this.state}
        newstate.loading = flag
        this.setState(newstate)
    }
    showTab(){
        switch(this.state.tabnumber){
            case 1: return <DeveloperPortalSummary setLoading={this.setLoading.bind(this)}/>
            case 2: return <DeveloperPortalCompanies setLoading={this.setLoading.bind(this)}/>
            case 3: return <DeveloperPortalBrokerage setLoading={this.setLoading.bind(this)}/>
            case 4: return <DeveloperPortalArthScoreFactors setLoading={this.setLoading.bind(this)}/>
            case 5: return <DeveloperPortalCredentials setLoading={this.setLoading.bind(this)}/>
            default: return <DeveloperPortalSummary setLoading={this.setLoading.bind(this)}/>
        }
    }
    render(){
        return <div className="c_container">
            <div style={this.state.developerPortalStyle} className="c_developerportal_container">
                <div className="row no-gutters">
                    <div className="c_developerportal_sidebar col-md-3">
                        <div className="c_developerportal_sidebar_logocontainer"><img alt="Logo" className="c_developerportal_sidebar_logo" src="/logoimage.png"/></div>
                        <div className="c_developerportal_sidebar_element" onClick={this.setTabNumber.bind(this, 1)}>Summary</div>
                        <hr/>
                        <div className="c_developerportal_sidebar_element" onClick={this.setTabNumber.bind(this, 2)}>Companies</div>
                        <div className="c_developerportal_sidebar_element" onClick={this.setTabNumber.bind(this, 3)}>Brokerage Recommendations</div>
                        <hr/>
                        <div className="c_developerportal_sidebar_element" onClick={this.setTabNumber.bind(this, 4)}>Arth Score Factors</div>
                        <div className="c_developerportal_sidebar_element" onClick={this.setTabNumber.bind(this, 5)}>Credentials</div>
                        <hr/>
                        <div className="c_developerportal_sidebar_element" onClick={this.onLogoutClicked.bind(this)}>Logout</div>
                    </div>
                    <div className="c_developerportal_main col-md-9">
                        {this.state.loading? "Loading": ""}
                        {this.showTab()}
                    </div>
                </div>
            </div>
        </div>
    }
    onLogoutClicked(){
        ApiHelper.localStorage.logout()
        this.props.history.replace("/login")
    }
    setTabNumber(tabnumber){
        const newstate = {...this.state}
        newstate.tabnumber = tabnumber
        this.setState(newstate)
    }
    componentDidMount(){
        var getinit = axios.post(ApiHelper.developerCredentials.initDeveloperPortal, {}, ApiHelper.getAccessTokenHeaderConfig())
        getinit.then((response) => {
            if(response.data.error === false){
                const newstate = {...this.state}
                newstate.developerPortalStyle = {
                    display: "block"
                }
                this.setState(newstate)
            }
        }, (error) => {
            this.props.history.replace("/login")
        })
    }
}
export default withRouter(DeveloperPortal)